import React from 'react';
import { RadarChart } from '../RadarChart';
import { usePresalesStore } from '@/stores/usePresalesStore';
import './PersonalCapabilities.css';

interface PersonalCapabilitiesProps {
  /** 紧凑模式：不占独立满屏 section，作为 TechnicalKnowledge 上方的能力概览 */
  compact?: boolean;
}

export const PersonalCapabilities: React.FC<PersonalCapabilitiesProps> = ({ compact = false }) => {
  const { excelData } = usePresalesStore();

  return (
    <section className={`cap-section ${compact ? 'cap-section--compact' : ''}`}>
      {!compact && (
        <>
          <div className="cap-bg-grid" aria-hidden></div>
          <div className="cap-bg-glow cap-bg-glow-a" aria-hidden></div>
          <div className="cap-bg-glow cap-bg-glow-b" aria-hidden></div>
        </>
      )}

      <div className="cap-container">
        {/* 标题区：compact 模式下由外层 TechnicalKnowledge header 承担, 此处只保留雷达 */}
        {!compact && (
          <div className="cap-header">
            <div className="cap-eyebrow">
              <span className="cap-eyebrow-dot"></span>
              <span>CAPABILITY MATRIX</span>
            </div>
            <h2 className="cap-title">个人能力素质</h2>
          </div>
        )}

        {/* 两张雷达图 */}
        <div className="cap-grid">
          <article className="cap-card">
            <div className="cap-card-header">
              <div className="cap-card-badge">01</div>
              <div>
                <h3 className="cap-card-title">{excelData.comprehensive.title}</h3>
                <p className="cap-card-desc">通用售前 SA 能力模型 · 6 维评估</p>
              </div>
            </div>
            <RadarChart
              title={excelData.comprehensive.title}
              data={excelData.comprehensive}
            />
          </article>

          <article className="cap-card">
            <div className="cap-card-header">
              <div className="cap-card-badge">02</div>
              <div>
                <h3 className="cap-card-title">{excelData.technical.title}</h3>
                <p className="cap-card-desc">云计算 × AI 技术栈 · 10 维评估</p>
              </div>
            </div>
            <RadarChart
              title={excelData.technical.title}
              data={excelData.technical}
            />
          </article>
        </div>

        {/* 底部说明 —— 紧凑模式下省略，避免与下方 TechnicalKnowledge 头部信息重复 */}
        {!compact && (
          <div className="cap-footer">
            <div className="cap-footer-item">
              <i className="fas fa-info-circle"></i>
              <span>评分为个人自评 · 50-100 区间显示 · Hover 数据点查看详情</span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PersonalCapabilities;
